<template>
  <div>
    <br>
    <v-layout row>
      <v-flex xs12>
        <v-divider></v-divider>
        <v-list dense>
          <v-list-group
            v-for="(item, index) in items"
            :key="item.title"
            v-model="item.active"
            no-action>
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <v-list-tile
                v-for="(subItem, subIndex) in item.items"
                :key="subItem.title"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.Asset.NAME }}: {{ subItem.Asset.DESCRIPTION }} - {{ subItem.Asset.CAPACITY }} GLNS</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action v-if="isStaff()">
                  <v-icon small @click="deleteTank(index, subIndex)">delete</v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <template v-if="isStaff()">
                <v-list-tile v-if="index == 0">
                  <v-autocomplete single-line v-on:change="updateTank"
                      v-model = "tank"
                      :items='tanks'
                      item-text='NAME'
                      item-value='id'
                      label='Tanks'
                      return-object
                    >
                    <template slot="item" slot-scope="data">
                      {{data.item.NAME}} - {{ data.item.DESCRIPTION }} - {{ data.item.CAPACITY }} GLNS
                    </template>
                  </v-autocomplete>
                </v-list-tile>
              </template>
              <template v-if="isStaff()">
                <v-list-tile v-if="index == 1">
                  <v-autocomplete single-line v-on:change="updateTBin"
                      v-model = "tank"
                      :items='tbins'
                      item-text='NAME'
                      item-value='id'
                      label='T-Bins'
                      return-object
                    >
                    <template slot="item" slot-scope="data">
                      {{data.item.NAME}} - {{ data.item.DESCRIPTION }} - {{ data.item.CAPACITY }} GLNS
                    </template>
                  </v-autocomplete>
                </v-list-tile>
              </template>
              <template v-if="isStaff()">
                <v-list-tile v-if="index == 2">
                  <v-autocomplete single-line v-on:change="updatePortaTank"
                      v-model = "tank"
                      :items='portaTanks'
                      item-text='NAME'
                      item-value='id'
                      label='Porta Tanks'
                      return-object
                    >
                    <template slot="item" slot-scope="data">
                      {{data.item.NAME}} - {{ data.item.DESCRIPTION }} - {{ data.item.CAPACITY }} GLNS
                    </template>
                  </v-autocomplete>
                </v-list-tile>
              </template>
              <template v-if="isStaff()">
                <v-list-tile v-if="index == 3">
                  <v-autocomplete single-line v-on:change="updateBBLFerms"
                      v-model = "tank"
                      :items='bblFerms'
                      item-text='NAME'
                      item-value='id'
                      label='BBL FERMS'
                      return-object
                    >
                    <template slot="item" slot-scope="data">
                      {{data.item.NAME}} - {{ data.item.DESCRIPTION }} - {{ data.item.CAPACITY }} GLNS
                    </template>
                  </v-autocomplete>
                </v-list-tile>
              </template>
              <template v-if="isStaff()">
                <v-list-tile v-if="index == 4">
                  <v-autocomplete single-line v-on:change="updatePress"
                      v-model = "tank"
                      :items='presses'
                      item-text='NAME'
                      item-value='id'
                      label='Presses'
                      return-object
                    >
                    <template slot="item" slot-scope="data">
                      {{data.item.NAME}} - {{ data.item.DESCRIPTION }} - {{ data.item.CAPACITY }} GLNS
                    </template>
                  </v-autocomplete>
                </v-list-tile>
              </template>
          </v-list-group>
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import myMixins from '../mixins/myMixins'
import axios from 'axios'
export default {
  props: ['wo', 'reservations'],
  mixins: [myMixins],
  data: () => ({
    tank: {},
    items: [
      {
        title: 'Tanks',
        items: []
      },
      {
        title: 'T-Bins',
        items: []
      },
      {
        title: 'Porta-Tanks',
        items: []
      },
      {
        title: 'BBL-Ferms',
        items: []
      },
      {
        title: 'Presses',
        items: []
      }

    ]
  }),
  methods: {
    deleteTank (index, subIndex) {
      let url = process.env.VUE_APP_BACKEND + 'reservations/' + this.items[index].items[subIndex].id
      axios
        .delete(url)
        .then(response => {
        })
      this.items[index].items.splice(subIndex, 1)
      this.updateTitles()
    },
    updateTank (item) {
      let res = {
        woid: this.wo.id,
        Asset: item
      }
      let url = process.env.VUE_APP_BACKEND + 'reservations'
      axios
        .post(url, res)
        .then(response => {
        })
      this.items[0].items.push(res)
      this.tank={}
      this.updateTitles()
    },
    updateTBin (item) {
      let res = {
        woid: this.wo.id,
        Asset: item
      }
      let url = process.env.VUE_APP_BACKEND + 'reservations'
      axios
        .post(url, res)
        .then(response => {
        })
      this.items[1].items.push(res)
      this.tank={}
      this.updateTitles()
    },
    updatePress (item) {
      console.log(JSON.stringify(item, null, 2))
      let res = {
        woid: this.wo.id,
        Asset: item
      }
      // let url = process.env.VUE_APP_BACKEND + 'reservations'
      // axios
      //   .post(url, res)
      //   .then(response => {
      //   })
      // this.items[3].items.push(res)
      // this.tank={}
      // this.updateTitles()
    },
    updatePortaTank (item) {
      let res = {
        woid: this.wo.id,
        Asset: item
      }
      let url = process.env.VUE_APP_BACKEND + 'reservations'
      axios
        .post(url, res)
        .then(response => {
        })
      this.items[2].items.push(res)
      this.tank={}
      this.updateTitles()
    },
    updateBBLFerms (item) {
      let res = {
        woid: this.wo.id,
        Asset: item
      }
      let url = process.env.VUE_APP_BACKEND + 'reservations'
      axios
        .post(url, res)
        .then(response => {
        })
      this.items[3].items.push(res)
      this.tank={}
      this.updateTitles()
    },
    updateTitles () {
      this.items[0].title = 'Tanks - ' + this.items[0].items.length
      this.items[1].title = 'T-Bins - ' + this.items[1].items.length
      this.items[2].title = 'Porta Tanks - ' + this.items[2].items.length
      this.items[3].title = 'BBL Ferms - ' + this.items[3].items.length
      this.items[4].title = 'Presses - ' + this.items[4].items.length
    }
  },
  computed: {
    presses () {
      return this.$store.state.presses
    },
    tanks () {
      return this.$store.state.tanks
    },
    tbins () {
      return this.$store.state.tbins
    },
    bblFerms () {
      return this.$store.state.bblFerms
    },
    portaTanks () {
      return this.$store.state.portatanks
    }
  },
  created () {
    this.items.forEach(item => {
      item.items = []
    })
    this.reservations.forEach(res => {
      if (res.Asset.TYPEID === 6) {
        this.items[0].items.push(res)
      }
      if (res.Asset.TYPEID === 8) {
        this.items[1].items.push(res)
      }
      if (res.Asset.TYPEID === 14) {
        this.items[2].items.push(res)
      }
      if (res.Asset.TYPEID === 7) {
        this.items[3].items.push(res)
      }
      if (res.Asset.TYPEID === 2) {
        this.items[4].items.push(res)
      }
    })
    this.updateTitles()
  }
}
</script>
<style>
</style>
